import React, { createRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import "./Services.css";

import HeaderBar from "../../components/HeaderBar";
import Design from "./../../assets/icons/camera.svg";
import Tourism from "./../../assets/icons/tourism.svg";
import Tech from "./../../assets/icons/coding1.svg";
import API from "./../../assets/icons/api.svg";

const Services = () => {
  const firstAbs = createRef();
  const secondAbs = createRef();
  const thirdAbs = createRef();
  const fourthAbs = createRef();

  return (
    <div className="outerContainer">
      <div className="container">
        <HeaderBar delay={0.1} />
        <div className="servicesContainer">
          <div className="serviceCard">
            <div className="serviceCardDetailsCont">
              <div className="serviceCardAbs">
                <div className="serviceCardIconCont">
                  <img className="serviceCardIcon" src={Tech} />
                </div>
              </div>
              <div className="serviceCardDetails">
                <div className="serviceCardDetailsHeader">Technology</div>
                <div className="serviceCardDetailsBody">
                  Building apps, websites and more...
                </div>
              </div>
            </div>
          </div>

          <div className="serviceCard">
            <div className="serviceCardDetailsCont">
              <div ref={secondAbs} className="serviceCardAbs">
                <div className="serviceCardIconCont">
                  <img className="serviceCardIcon" src={Design} />
                </div>
              </div>
              <div className="serviceCardDetails">
                <div className="serviceCardDetailsHeader">Designs</div>
                <div className="serviceCardDetailsBody">
                  Capture & Beautify the moments...
                </div>
              </div>
            </div>
          </div>

          <div className="serviceCard">
            <div className="serviceCardDetailsCont">
              <div ref={thirdAbs} className="serviceCardAbs">
                <div className="serviceCardIconCont">
                  <img className="serviceCardIcon" src={Tourism} />
                </div>
              </div>
              <div className="serviceCardDetails">
                <div className="serviceCardDetailsHeader">Travel & Tourism</div>
                <div className="serviceCardDetailsBody">
                  Experience the beauty of the world...
                </div>
              </div>
            </div>
          </div>

          <div className="serviceCard">
            <div className="serviceCardDetailsCont">
              <div ref={fourthAbs} className="serviceCardAbs">
                <div className="serviceCardIconCont">
                  <img className="serviceCardIcon" src={API} />
                </div>
              </div>
              <div className="serviceCardDetails">
                <div className="serviceCardDetailsHeader">APIs</div>
                <div className="serviceCardDetailsBody">
                  Integrate all the results with our API...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
